import * as React from 'react';
import { Card, CardImg, CardBody, CardTitle, CardText, Button } from 'reactstrap';
import { NavLink as Link } from 'react-router-dom';

const folderPath = 'https://betting-books.stevedavo.com/resources/icons/';

interface ICardCompProps {
  iconName: string;
  bookTitle: string;
  bookDescription: string;
  bookUrl: string;
  bookId: number;
  subscriptionStatus: boolean;
}

// TypeScript 2.8's img type has no loading attribute, so it is passed by spread
const lazyLoading: any = { loading: 'lazy', decoding: 'async' };

export const CardComp: React.SFC<ICardCompProps> = props => (
  <Card className="card-comp">
    <div className="card-img-container">
      <CardImg top src={folderPath + props.iconName} alt={props.bookTitle} {...lazyLoading} />
    </div>
    <CardBody className="card-comp-body">
      <CardTitle className="card-comp-title">{props.bookTitle}</CardTitle>
      <div className="card-comp-actions">
        {props.subscriptionStatus === false ? (
          <Button href={`${props.bookDescription}`} target="_blank" color="warning" block>
            More Info
          </Button>
        ) : (
          <Button color="success" tag={Link} to={`/home/${props.bookId}/0`} block>
            View
          </Button>
        )}
      </div>
    </CardBody>
  </Card>
);
